import { render, staticRenderFns } from "./UpdateCellphone.vue?vue&type=template&id=49be8100&"
import script from "./UpdateCellphone.vue?vue&type=script&lang=js&"
export * from "./UpdateCellphone.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCellphone.vue?vue&type=style&index=0&id=49be8100&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports